import { Transform } from "../../../geometry/transformation";
import { getShapeRendererGroup } from "./shapeCategorySingleton";


interface RenderSelectionProps {
    selectedItems: GeometricShape[],
    transform?: Transform,
}

const RenderSelection = ({ selectedItems, transform }: RenderSelectionProps) => {



    const selectedRender = (shape: GeometricShape) => {
        const elementTransformation = transform ?
            new Transform(shape.transformation).multiply(transform) :
            new Transform();
        const previewShape = { ...shape, id: -2, transformation: elementTransformation.m }
        const rend = getShapeRendererGroup(shape.type)?.baseShapeRenderer;
        const renderedElement = rend?.({ ...previewShape, transformation: elementTransformation.m },)
        return renderedElement || <></>;
    }
    return (
        <>
            {selectedItems.map((s) => selectedRender(s))}
        </>
    )

}
export default RenderSelection;